import _get from 'lodash.get';
import { notify } from '../../Notifications';
import SILENCED_ERRORS, { FORBIDDEN } from '../constants/silencedErrors';
import { GENERIC_ERROR_MSG } from '../constants/genericError';

function getErrorCode(error) {
  return _get(error, 'extensions.code') ||
  _get(error, 'graphQLErrors[0].extensions.code') ||
  _get(error, 'networkError.result.errors[0].extensions.code');
}

function getException(error) {
  return _get(error, 'extensions.exception') ||
  _get(error, 'graphQLErrors[0].extensions.exception');
}

function isSilencedError(error) {
  const code = getErrorCode(error);

  return code && SILENCED_ERRORS[code];
}

async function makeRequest(
request,
{
  isSilent,
  useGenericError = true,
  ...params
},
promptRequestAccess)
{
  try {
    const { data, errors } = await request(params);
    const isError = errors && errors.length;

    let errorMessage = GENERIC_ERROR_MSG;
    if (isError && !useGenericError && errors[0]?.graphQLErrors) {
      errorMessage = errors[0].graphQLErrors[0].message;
    }

    if (isError && !isSilencedError(errors[0]) && !isSilent) {
      notify({
        type: 'error',
        content: errorMessage
      });
    }

    if (isError && getErrorCode(errors[0]) === FORBIDDEN) {
      const exception = getException(errors[0]);

      if (exception?.ownerId) {
        promptRequestAccess({ resourceOwnerId: exception.ownerId });
      }
    }

    return { data, error: isError ? errorMessage : void 0 };
  } catch (err) {
    let errorMessage = GENERIC_ERROR_MSG;
    if (!useGenericError && err.graphQLErrors) {
      errorMessage = err.graphQLErrors[0].message;
    }

    if (!isSilencedError(err) && !isSilent) {
      notify({
        type: 'error',
        content: errorMessage
      });
    }

    if (getErrorCode(err) === FORBIDDEN) {
      const exception = getException(err);

      if (exception?.ownerId) {
        promptRequestAccess({ resourceOwnerId: exception.ownerId });
      }
    }

    return {
      error: errorMessage
    };
  }
}

export default makeRequest;